module.exports = __webpack_public_path__ + "static/media/levels_5_4.95564fa6.svg";